"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppointmentPath = void 0;
function getAppointmentPath(service, country) {
    if (service === "bag") {
        switch (country) {
            case "AR": {
                return "assignations/online_clinica_medica/bag";
            }
            // MX enters in this option
            default: {
                return `assignations/bag/${country}`;
            }
        }
    }
    else {
        return `assignations/${service}/${country}`;
    }
}
exports.getAppointmentPath = getAppointmentPath;
